module.exports = __webpack_public_path__ + "static/media/Slack.fba547c0.svg";